import {
	type ExperienceManifest,
	type ExperienceManifestId,
} from '../../common/types/experience/types';
import type { URLMetaData } from '../../common/types/url/types';

let experienceService: ExperienceManifestRegistry | undefined;

export function getExperienceManifestRegistry() {
	if (experienceService) {
		return experienceService;
	}
	experienceService = new ExperienceManifestRegistry();
	return experienceService;
}

export class ExperienceManifestRegistry {
	private experienceManifests: ExperienceManifest[] = [];

	registerExperienceManifest(experienceManifest: ExperienceManifest) {
		this.experienceManifests.push(experienceManifest);
	}

	getExperienceIdFromUrl(url: string): ExperienceManifestId | undefined {
		return this.experienceManifests.find((experience) => experience.isUrlMatch(url))?.id;
	}

	getManifestByUrl(url: string): ExperienceManifest | undefined {
		return this.experienceManifests.find((experience) => experience.isUrlMatch(url));
	}

	getAllExperienceIds(): ExperienceManifestId[] {
		return this.experienceManifests.map((experience) => experience.id);
	}

	getManifestByUrlMeta(urlMeta: URLMetaData): ExperienceManifest | undefined {
		return this.experienceManifests.find(
			(experience) => experience.isUrlMatch(urlMeta.url) && experience.isActive(urlMeta),
		);
	}

	async getExperienceById(id: string) {
		return this.experienceManifests.find((experience) => experience.id === id);
	}
}
